/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    func, shape, string, object,
} from 'prop-types';
import findProductPageByPartNumber from '../../../../../gql/queries/findProductPageByPartNumber';
import GraphqlPortalLoader from '../../../GraphqlCommonComponents/GraphqlPortalLoader';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { setProductDemandType } from '../../../../../helpers/page/pageHelpers';

// Higher Order Component that redirects to the Selected Upsell.
// children gets a function that can be triggered onClick that redirects to upsell
const RedirectToSku = ({
    children: Component,
    selectedSkuId,
    onChange,
    brand,
    history,
}) => {
    const FIND_PDP_BY_PART = findProductPageByPartNumber(brand['domain-name'], selectedSkuId);
    const [loadPDP, { errorPDP, loading, data }] = useLazyQuery(FIND_PDP_BY_PART);
    const [demandType, setDemandType] = useState('');
    if (loading) {
        return <GraphqlPortalLoader />;
    }

    if (errorPDP) {
        return mbpLogger.logError({ appName: process.env.npm_package_name, message: `error prefetching PDP  ${errorPDP}` });
    }

    if (data) {
        const productURL = data?.findProductPageByPartNumber?.product?.seo?.url || null;
        if (history.location.pathname !== productURL) {
            history.push({
                pathname: productURL,
            });
            if (demandType) {
                setProductDemandType(history, demandType);
            }
        }
    }

    const handleSkuChange = (event, sku) => {
        const modifiedEvent = event;
        modifiedEvent.target.value = sku.id;
        if (sku?.__typename === 'Upsell') {
            setDemandType('UP');
        } else {
            setDemandType('');
        }
        onChange(modifiedEvent);
        loadPDP();
    };

    return (
        <Component redirectToSku={handleSkuChange} />
    );
};

RedirectToSku.propTypes = {
    selectedSkuId: string.isRequired,
    children: func.isRequired,
    brand: shape({
        'domain-name': string,
    }),
    history: object.isRequired,
    onChange: func.isRequired,
};

RedirectToSku.defaultProps = {
    brand: {
        'domain-name': 'harryanddavid',
    },
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(withRouter(RedirectToSku));
